export default __webpack_public_path__ + "static/media/st. alex church.1095d1cb.jpg";